import React from "react";
import { useTranslation } from "react-i18next";
import PropTypes from "prop-types";
import styled from "styled-components";

import DiscardChangesPopup from "../sharedComponents/DiscardChangesPopup";
import { ReactComponent as WarningIcon } from "../../assets/svg/warning-icon-popup.svg";
import { BLACK_85, BLACK_65 } from "../../constant/colors";

// Softened title/description text (antd Modal.confirm typography scale), scoped to
// this popup so the shared DiscardChangesPopup keeps its own palette.
const Title = styled.span`
  color: ${BLACK_85};
`;

const Description = styled.span`
  color: ${BLACK_65};
`;

/**
 * The "Discard bulk selection?" confirmation, shown whenever leaving an open
 * bulk action would drop the selection. Centralizes the warning icon and the
 * four bulk_actions.* copy keys so every guard (sidebar/logo, cross-route, and
 * the save-as-new-list gate) renders an identical prompt — change the wording
 * or icon here once instead of in each call site.
 */
const BulkActionDiscardPopup = ({ visible, onClickDiscard, onClickCancel }) => {
  const { t } = useTranslation();
  return (
    <DiscardChangesPopup
      visible={visible}
      onClickDiscard={onClickDiscard}
      onClickCancel={onClickCancel}
      popupTitle={<Title>{t("bulk_actions.unsaved_changes_title")}</Title>}
      popupDescription={<Description>{t("bulk_actions.unsaved_changes_description")}</Description>}
      okText={t("bulk_actions.discard_and_leave")}
      cancelText={t("bulk_actions.stay")}
      icon={<WarningIcon />}
    />
  );
};

BulkActionDiscardPopup.propTypes = {
  visible: PropTypes.bool.isRequired,
  onClickDiscard: PropTypes.func.isRequired,
  onClickCancel: PropTypes.func.isRequired
};

export default BulkActionDiscardPopup;
